import get from "get-value";
import React from "react";
import { FormattedMessage, injectIntl } from "react-intl";
import { connect } from "react-redux";
import { bindActionCreators } from 'redux';
import { formValueSelector, getFormInitialValues } from "redux-form";
import { fetchAseInternalTicketSgInfo } from "../../../../../../actions/ase/actionAseInternalTicket";
import {
    FORM_FIELD_PRIORITY_JUSTIFICATION,
    FORM_FIELD_PRIORITY_TREATMENT,
    FORM_FIELD_REQUESTOR_GROUP,
    FORM_FIELD_REQUESTOR_NAME,
    FORM_FIELD_SOLUTION_GROUP,
    FORM_LABEL_PRIORITY,
    FORM_LABEL_PRIORITY_JUSTIFICATION,
    FORM_LABEL_REQUESTOR_GROUP,
    FORM_LABEL_REQUESTOR_NAME,
    FORM_LABEL_SOLUTION_GROUP,
    FORM_TICKET_SECTION,
} from "../../../../../../constants/formConstants";
import {
    priorityJustification,
    priorityTreatment,
    YES,
} from "../../../../../../constants/Utils";
import formMessages from "../../../../../../intl/afterSales/formMessages";
import priorityJustificationMessages from "../../../../../../intl/afterSales/priorityJustificationMessages";
import commonMessages from "../../../../../../intl/common/commonMessages";
import { InputFieldWithValidation } from "../../../../../common/InputFieldWithValidation";
import InputSelectFieldWithValidation from "../../../../../common/InputSelectFieldWithValidation";
import BorderRadius from "../../../../../common/styled/BorderRadius";

const colClassName = "col-xl-3 col-lg-4 col-md-6 col-sm-12 pb-2";

const RequestorInformationSection = (props) => {
    const {
        priorityValue,
        reqFields,
        readOnly,
        userRights,
        roles,
    } = props;

    const handleChange = (event, value) => {
        props.fetchAseInternalTicketSgInfo(value);
    };

    const sgOptions = get(roles, "ASE.sgEditor.sgPermission", []).filter(sg => !sg.name || !sg.name.includes('L3')).map((sg) => ({
        uuid: sg.id,
        presetName: sg.name,
    }));

    return (
        <>
            <h3 className="text-left ml-4">
                <FormattedMessage
                    {...formMessages.REQUESTOR_INFORMATION_SECTION}
                />
            </h3>
            <BorderRadius
                size={5}
                className="border border-secondary px-4 py-2 bg-white"
            >
                <div className="form-row">
                    <div className={colClassName}>
                        <InputFieldWithValidation
                            label={formMessages[FORM_LABEL_REQUESTOR_NAME]}
                            field={FORM_FIELD_REQUESTOR_NAME}
                            isRequired={reqFields.includes(
                                FORM_FIELD_REQUESTOR_NAME,
                            )}
                            isSmall
                            isDisabled
                        />
                    </div>
                    <div className={colClassName}>
                        <InputFieldWithValidation
                            label={formMessages[FORM_LABEL_REQUESTOR_GROUP]}
                            field={FORM_FIELD_REQUESTOR_GROUP}
                            isRequired={reqFields.includes(
                                FORM_FIELD_REQUESTOR_GROUP,
                            )}
                            isSmall
                            isDisabled
                        />
                    </div>
                    <div className={colClassName}>
                        <InputSelectFieldWithValidation
                            label={formMessages[FORM_LABEL_SOLUTION_GROUP]}
                            field={FORM_FIELD_SOLUTION_GROUP}
                            customOptionsMsg={sgOptions}
                            isRequired={reqFields.includes(
                                FORM_FIELD_SOLUTION_GROUP,
                            )}
                            isDisabled={
                                !userRights.canEditInternalTicketRequestDetail ||
                                readOnly
                            }
                            handleChange={handleChange}
                        />
                    </div>
                </div>
                <div className="form-row">
                    <div className={colClassName}>
                        <InputSelectFieldWithValidation
                            label={formMessages[FORM_LABEL_PRIORITY]}
                            field={FORM_FIELD_PRIORITY_TREATMENT}
                            isRequired={reqFields.includes(
                                FORM_FIELD_PRIORITY_TREATMENT,
                            )}
                            isDisabled={
                                !userRights.canEditInternalTicketRequestDetail ||
                                readOnly
                            }
                            options={priorityTreatment}
                            intlMessages={commonMessages}
                        />
                    </div>
                    {priorityValue === YES && (
                        <div className={colClassName}>
                            <InputSelectFieldWithValidation
                                label={
                                    formMessages[
                                        FORM_LABEL_PRIORITY_JUSTIFICATION
                                    ]
                                }
                                field={FORM_FIELD_PRIORITY_JUSTIFICATION}
                                options={priorityJustification}
                                intlMessages={priorityJustificationMessages}
                                isRequired={reqFields.includes(
                                    FORM_FIELD_PRIORITY_JUSTIFICATION,
                                )}
                                isDisabled={
                                    !userRights.canEditInternalTicketRequestDetail ||
                                    readOnly
                                }
                            />
                        </div>
                    )}
                </div>
            </BorderRadius>
        </>
    );
};

const mapStateToProps = (state, props) => ({
    initialValues: getFormInitialValues(props.form)(state),
    roles: state.profile.userDetail.roles,
    priorityValue: formValueSelector(props.form)(
        state,
        `${FORM_TICKET_SECTION}.${FORM_FIELD_PRIORITY_TREATMENT}`,
    ),
});

const mapDispatchToProps = (dispatch, props) => ({
    ...bindActionCreators({ fetchAseInternalTicketSgInfo }, dispatch)
});

export default injectIntl(
    connect(mapStateToProps, mapDispatchToProps)(RequestorInformationSection),
);
